import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { Box, Chip } from "@mui/material";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import useResizeObserver from "use-resize-observer";

const useStyles = makeStyles<Theme>((theme: Theme) => {
    return {
        chip: {
            margin: theme.spacing(0.5),
            fontWeight: 600,
            height: 28,
            borderWidth: "1px",
            color: theme.palette.primary.main,
            borderColor: theme.palette.neutrals.light,
            background: theme.palette.neutrals.light,
            "&:hover, &:focus": {
                background: `${theme.palette.neutrals.light} !important`,
                boxShadow: "0 2px 7px 0 #00000026",
            },
            "& .MuiChip-label": {
                fontSize: 12,
                fontWeight: 400,
                color: theme.palette.common.black,
                letterSpacing: "0.4px",
                textTransform: "capitalize",
            },
            "& .MuiChip-deleteIcon": {
                color: theme.palette.button.active.to,
                width: 18,
                "&:hover": {
                    color: theme.palette.button.active.to,
                },
            },
        },
    };
});

const TeamChips = ({ chips }: { chips: any[] }) => {
    const classes = useStyles();

    const [chipConfig, setChipConfig] = useState<any>(null);
    const [hiddenChipsCount, setHiddenChipsCount] = useState(0);

    const chipRefs = useRef<HTMLDivElement[]>([]);
    const chipsWrapperRef = useRef<HTMLDivElement>(null);
    const { ref: resizableWrapper, width = -1, height = -1 } = useResizeObserver<HTMLDivElement>();

    useEffect(() => {
        // Get 1st chip as reference for Y position and height.
        const config = chipRefs.current[0].getBoundingClientRect();
        setChipConfig(config);

        // Count all chips which y is higher than the reference. Those are the +nn chips
        setHiddenChipsCount(
            chipRefs.current.filter((chip) => chip.getBoundingClientRect().y > config.y + config.height).length
        );
    }, [width, height]);

    // console.log(width);

    const handleChipClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.stopPropagation();
    };

    return (
        <Box
            sx={{ display: "flex", flexWrap: "nowrap", alignItems: "center", position: "relative" }}
            ref={resizableWrapper}
        >
            <Box
                sx={{
                    height: chipConfig?.height + 4,
                    overflow: "hidden",
                    // outline: "1px solid",
                }}
                ref={chipsWrapperRef}
            >
                {chips.map((chip, i) => (
                    <Chip
                        onClick={handleChipClick}
                        color="default"
                        className={classes.chip}
                        key={chip.id}
                        label={chip.name}
                        ref={(el) => {
                            chipRefs.current[i] = el as HTMLDivElement;
                        }}
                    />
                ))}
            </Box>
            {Boolean(hiddenChipsCount) && <Chip className={classes.chip} label={`+${hiddenChipsCount}`} />}
        </Box>
    );
};

export default TeamChips;
